import React, { Component } from 'react';
import { BrowserRouter as Router, Route, Link, Switch } from "react-router-dom";

import Header from './components/landingpage/header/Header';

//import Ranking from './components/landingpage/leftCol/Ranking';

import TuneIn from './components/landingpage/leftCol/TuneIn';

import Leaderboard from './components/landingpage/leaderboard/Leaderboard';

import GamePage from './components/gamepage/GamePage';

import {highScoresThisMonthFromGSNTV, isIframed} from './utils/gsntv';


import './../scss/App.scss';
import { trackingWrapper } from './utils/analytics';
import IronSourceInitializerContainer from './containers/IronSourceInitializerContainer';
import LandingVideo from './components/landingpage/leftCol/LandingVideo';


class App extends Component {

	constructor(props){
		super(props);

		this.state = {
			page : "",
			landingTransitionOut : false,
			dataReady : false
		}

		this.showPage = this.showPage.bind(this);
		this.handleTransitionOut = this.handleTransitionOut.bind(this);
	}

	componentDidMount(){
		//console.log("componentDidMount");
		this.initData();
		this.showPage("landing");

		// disable "tab" keyboard input
		window.$(document).keydown(function(e){
			if(e.keyCode === 9 || e.keyCode === 37 || e.keyCode === 38 || e.keyCode === 39 || e.keyCode === 40){
				e.preventDefault();
			}
		});

		// pressing "enter" forces blur on fields
		window.$(document).keydown(function(e){
			if(e.keyCode === 13){
				window.$("input[type=text]").blur();
			}
		});

		// tracking
		trackingWrapper('event', 'ASgame-page-loaded', {'event_category':'america-says-game'});

		this.props.setAffiliate('fox9');
		if (this.props.match) {
			this.props.setAffiliate(this.props.match.params.affiliate);
		}
	}

	componentWillUpdate(nextProps, nextState){

		if(nextState.page === "landing" && this.state.page === "game" && !isIframed()){
			//console.log("App :: componentWillUpdate - not iframed - will set dataReady true");
			this.setState({
				dataReady : true
			});
		}
		else if(nextState.page === "landing" && this.state.page !== "landing"){
			//console.log("App :: componentWillUpdate - going to landing");

			this.setState({
				dataReady : false
			});

			// 
			//console.log("App :: componentWillUpdate - about to check if iframed");

			const _this = this;

			if(isIframed()){
				//console.log("App :: componentWillUpdate - is iframed");

				highScoresThisMonthFromGSNTV().then((data) => {
					//console.log("App :: highScoresThisMonthFromGSNTV - data ", data);

					window.highScores = {...data};

					_this.setState({
						dataReady : true
					});
				});
			}
		}
	}

	initData(){
		console.log("App :: initData - v41");

		const _this = this;

		window.$.when(
			window.$.getJSON("data/config.json", function(data) {
				window.config = {...data};
				window.videoAdsPool = [...data.videoAd.videos];
			}),
			window.$.getJSON("data/questions.json", function(data) {
				window.questions = {};
				window.questionsPool = {};

				window.questions.easy = [...data.easy];
				window.questionsPool.easy = [...data.easy];

				window.questions.medium = [...data.medium];
				window.questionsPool.medium = [...data.medium];

				window.questions.hard = [...data.hard];
				window.questionsPool.hard = [...data.hard];
			}),
			window.$.getJSON("data/bonusQuestions.json", function(data) {
				window.bonusQuestions = {};
				window.bonusQuestionsPool = {};

				window.bonusQuestions["1"] = [...data["1"]];
				window.bonusQuestionsPool["1"] = [...data["1"]];

				window.bonusQuestions["2"] = [...data["2"]];
				window.bonusQuestionsPool["2"] = [...data["2"]];

				window.bonusQuestions["3"] = [...data["3"]];
				window.bonusQuestionsPool["3"] = [...data["3"]];

				window.bonusQuestions["4"] = [...data["4"]];
				window.bonusQuestionsPool["4"] = [...data["4"]];
			}),
			window.$.getJSON("data/alternateWords.json", function(data) {
				window.alternateWords = {...data};
			}),
			window.$.getJSON("data/leaderboard.json", function(data) {
				window.leaderboard = {...data};
			})
		).then(function() {
			if (window.config && window.questions && window.bonusQuestions && window.alternateWords) {
				console.log("App :: json loaded");

				if(!isIframed()){
					_this.setState({
						dataReady : true
					});
				}
			}
			else {
				console.log("App :: json load failed");
			}
		});
	}

	showPage(pageName){

		this.setState({
			page : pageName,
			landingTransitionOut : false
		});

		// play bg
		if(pageName === "landing"){
			window.sounds.roundBg.stop();
			window.sounds.bonusBg.stop();
			window.sounds.introBg.play();
		}

	}

	handleTransitionOut(){
		this.setState({
			landingTransitionOut : true
		});
	}

	route_page(){
		//console.log("App :: route_page");
		
		if(this.state.dataReady){
			//console.log("App :: route_page - dataReady");
			if(this.state.page === "landing"){
				//console.log("App :: route_page - render landing");
				return(
					<div className="page landing">
						<div className="header_wrapper">
							<div className="content">
								<Header showPage={this.showPage} handleTransitionOut={this.handleTransitionOut} />
							</div>
						</div>

						<div className="leftCol_wrapper">
								{/*<Ranking page={this.state.page} landingTransitionOut={this.state.landingTransitionOut} />*/}
								<TuneIn landingTransitionOut={this.state.landingTransitionOut} />
						</div>

						<div className="leaderboard_wrapper">
							<div className="content">
								<LandingVideo landingTransitionOut={this.state.landingTransitionOut} />
								{
									// <Leaderboard landingTransitionOut={this.state.landingTransitionOut} />
								}
							</div>
						</div>
					</div>
				);
			}
			else if(this.state.page === "game"){
				return(
					<GamePage showPage={this.showPage} store={this.props.store} />
				);
			}
		}
	}

	render() {
		//console.log("App :: render - bonusQuestions", this.bonusQuestions);
		//console.log("App.js :: render - redux props", this.props.user);
		return (
			<div className="main_wrapper">
				{this.route_page()}
				<IronSourceInitializerContainer />
			</div>		
		);
	}
}

export default App;



// WEBPACK FOOTER //
// ./src/js/App.js